import type {
	CryptocurrencyCreateFormInput,
	CryptocurrencyEditFormInput,
} from "web_myplann/Portfolio/Forms/CryptocurrencyForm/cryptocurrencyFormSchema";

export const CRYPTOCURRENCY_EDIT_FORM_DEFAULT_VALUES: CryptocurrencyEditFormInput =
	{
		name: "",
		contractNumber: "",
		producer: "",
		product: "",
		signedAt: null,
		startAt: null,
		endAt: null,
		tools: [],
	};

export const CRYPTOCURRENCY_CREATE_FORM_DEFAULT_VALUES: CryptocurrencyCreateFormInput =
	{
		...CRYPTOCURRENCY_EDIT_FORM_DEFAULT_VALUES,
		value: null,
		invested: null,
		valueDate: null,
	};

export const getCryptocurrencyCreateFormDefaultValues =
	(): CryptocurrencyCreateFormInput => ({
		...CRYPTOCURRENCY_CREATE_FORM_DEFAULT_VALUES,
		valueDate: new Date(),
	});
